import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Styles Toastify
import '../../assets/css/selectroledash.css';
import '../../assets/css/responsive.css';
import './login.css';
import api from '../../service/caller'; // Axios instance configurée
import { useNavigate } from 'react-router-dom';

import imageOrangeTopLeft from '../../assets/images/Medic symbol circle.png';
import imageOrangeBottomLeft from '../../assets/images/Checklist.png';
import imageOrangeBottomright from '../../assets/images/DNA.png';
import logomedtinz from '../../assets/images/MedTinz.png';

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const navigate = useNavigate();

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const loginData = { email, password };
            const response = await api.post('/api/login', loginData);


            const accessToken = response.data.token;
            const userData = response.data.data;
            console.log(userData)
            const subscriptionRes = await api.get(
                `api/adminsubscriptions/${userData.main_hospital_id}`
            );
            const subscriptionData = subscriptionRes.data.subscription;

            // Détermination de la durée
            const now = new Date();
            const createdAt = new Date(subscriptionData.createdAt);
            let expiry = new Date(createdAt);

            if (subscriptionData.planDuration) {
                // Format spécifique à l'hôpital
                expiry.setMonth(expiry.getMonth() + subscriptionData.planDuration);
            } else if (subscriptionData.duration) {
                // Format global du plan
                expiry.setMonth(expiry.getMonth() + subscriptionData.duration);
            } else {
                console.warn('Durée de la souscription inconnue.');
                return;
            }

            if (now > expiry) {
                window.location.href = "/subscription/expired";
                return;
            }

            if (!accessToken) {
                throw new Error('Access token manquant dans la réponse');
            }

            // Vérifier si l'utilisateur est désactivé
            if (userData.status == 'deactivated') {
                toast.error('Votre compte est désactivé. Veuillez contacter l\'administrateur.');
                return;
            }

            // Si tout est OK
            localStorage.setItem('access_token', accessToken);
            toast.success('Connexion réussie !');

            window.location.href = userData.firstlogin
                ? '/hospitaladmin/firstLoginPasswordChange'
                : '/hospitaladmin/dashboard';

        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Erreur de connexion, vérifiez vos informations.';
            toast.error(errorMessage);
            // console.error(errorMessage)
        }
    };

    return (
        <div className='container-fluid' style={{ padding: '0px' }}>
            <ToastContainer />
            <section className='py-5 position-relative' style={{ background: '#0056B3' }}>
                <div className='container px-4 mt-5'>
                    <div className='row text-center'>
                        <div className='col-lg-3 mb-3'>
                            <div className='mt-2'>
                                <img src={logomedtinz} alt="Bottom left orange" className="logomedtinz" />
                            </div>
                        </div>
                        <div className='col-lg-6 mb-3'>
                            <h2 className='text-white text-center' style={{ fontSize: '45px', fontFamily: 'Inter,sans-serif', fontWeight: '600' }}>Connect Now To Your Dashboard</h2>
                        </div>
                    </div>
                    <div className='d-flex justify-content-center'>
                        <div style={{ width: '66%' }}>
                        </div>
                    </div>
                </div>
                <div style={{ position: 'absolute', right: '0', top: '0' }}>
                    <img src={imageOrangeTopLeft} />

                </div>
                <div style={{ position: 'absolute', left: '0', bottom: '-5rem' }}>
                    <img src={imageOrangeBottomLeft} />
                </div>
            </section>
            <section className='mt-5 container position-relative px-4'>
                <div className='row mt-5'>
                    <div className='col-lg-2 mb-3 mt-4 mt-md-0'>
                        <button onClick={()=> navigate(-1)} className='btn btn-primary rounded-pill py-3 px-4 fw-bold'><i className="bi bi-arrow-left me-2"></i>Retour</button>
                    </div>
                    <div className='col-lg-8 mb-3 py-4'>
                        <div className="text-center mb-5">
                            <h4 className="fw-bold">Enter your credentials</h4>
                        </div>

                        <form onSubmit={handleLogin}>

                            {/* Email avec étiquette flottante */}
                            <div className="form-floating mb-3">
                                <input
                                    type="email"
                                    className="form-control padi"
                                    id="email"
                                    style={{ border: '3px solid #0056B3' }}
                                    placeholder="name@example.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                                <label htmlFor="email" className='pad'>E-mail</label>
                            </div>

                            {/* Mot de passe avec étiquette flottante et icône */}
                            <div className="form-floating mb-3">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    className="form-control padi"
                                    id="password"
                                    style={{ border: '3px solid #0056B3' }}
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                                <label htmlFor="password" className='pad'>Password</label>
                                <button
                                    type="button"
                                    className="btn position-absolute end-0 top-50 translate-middle-y text-muted border-0"
                                    onClick={togglePasswordVisibility}
                                    style={{ zIndex: 5 }}
                                >
                                    <i className={`bi bi-${showPassword ? 'eye-slash' : 'eye'}`} style={{ color: '#0056B3', fontSize: '1.3rem' }}></i>
                                </button>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <div className="form-check padc">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="rememberMe"
                                        checked={rememberMe}
                                        onChange={() => setRememberMe(!rememberMe)}
                                    />
                                    <label className="form-check-label" style={{ fontWeight: '400' }} htmlFor="rememberMe">
                                        Remember me
                                    </label>
                                </div>
                                <a onClick={()=>{navigate('/forget-password')}} className="" style={{ cursor:"pointer", color: '#333333' }}>Forgot password?</a>
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary w-100 py-3 fw-bold text-white"
                                style={{ backgroundColor: '#0056b3', borderColor: '#0056b3' }}
                            >
                                Continue <span className="ms-1">→</span>
                            </button>
                        </form>
                    </div>

                </div>
                <div className='d-none d-lg-block'>
                    <div style={{ position: 'absolute', top: '80%', left: '83%' }}>
                        <img src={imageOrangeBottomright} />
                    </div>
                </div>

                <div className='img4'>
                    <p>© 2024 | Développé par ITTIQ </p>
                </div>
            </section>

        </div>
    );
}
export default LoginPage;
